import {
  Directive,
  ElementRef,
  EventEmitter,
  Output,
  Renderer2,
  OnDestroy,
  AfterViewInit,
  Input,
} from '@angular/core';

@Directive({
  selector: '[appClickOutside]',
  standalone: true
})
export class ClickOutsideDirective implements AfterViewInit, OnDestroy {
  @Output() appClickOutside = new EventEmitter<void>();

  @Input() ignoreElement?: HTMLElement;
  @Input() ignoreElements?: any[] = [];
  @Input() ignoreElementById?: string;

  private unlisten?: () => void;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.unlisten = this.renderer.listen(
        'document',
        'click',
        (event: MouseEvent) => {
          const target = event.target as Node;

          const clickedInsideHost = this.el.nativeElement.contains(target);
          const clickedInsideIgnored =
            this.ignoreElement?.contains(target) ||
            (this.ignoreElements &&
              this.ignoreElements.length &&
              this.ignoreElements.some((ele: HTMLElement) =>
                ele?.contains(target)
              ));

          let clickedInsideById = false;
          if (this.ignoreElementById) {
            const ignoredElement = document.getElementById(
              this.ignoreElementById
            );
            if (ignoredElement) {
              clickedInsideById = ignoredElement.contains(target);
            }
          }

          if (
            !clickedInsideHost &&
            !clickedInsideIgnored &&
            !clickedInsideById
          ) {
            this.appClickOutside.emit();
          }
        }
      );
    }, 0);
  }

  ngOnDestroy(): void {
    if (this.unlisten) {
      this.unlisten();
    }
  }
}
